export default function PageProgramacao() {
	const page = document.querySelector(".page-programacao");
	if (!page) return;

	const tabs = [...page.querySelectorAll(".pg-tab[data-pg-dia]")];
	const types = [...page.querySelectorAll(".pg-type[data-pg-tipo]")];
	const sessions = [...page.querySelectorAll(".pg-session[data-pg-dia]")];
	const empty = page.querySelector("[data-pg-empty]");
	let day = null;
	let type = null;

	const typesOf = (session) => session.dataset.tipos.split("|");

	const apply = () => {
		tabs.forEach((tab) => {
			const on = tab.dataset.pgDia === day;
			tab.classList.toggle("is-active", on);
			tab.setAttribute("aria-selected", on ? "true" : "false");
		});

		types.forEach((btn) => {
			const on = btn.dataset.pgTipo === type;
			btn.classList.toggle("is-active", on);
			btn.setAttribute("aria-selected", on ? "true" : "false");
			btn.tabIndex = on ? 0 : -1;
		});

		let i = 0;
		sessions.forEach((session) => {
			const on =
				session.dataset.pgDia === day && (!type || typesOf(session).includes(type));
			session.hidden = !on;
			if (on) session.style.setProperty("--pg-i", i++);
		});

		if (empty) empty.hidden = i > 0;
	};

	tabs.forEach((tab) => {
		tab.addEventListener("click", () => {
			day = tab.dataset.pgDia;
			apply();
		});
	});

	types.forEach((btn) => {
		btn.addEventListener("click", () => {
			type = btn.dataset.pgTipo;
			apply();
		});

		btn.addEventListener("keydown", (event) => {
			const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
			if (!step) return;
			const visible = types;
			const next = visible[(visible.indexOf(btn) + step + visible.length) % visible.length];
			event.preventDefault();
			type = next.dataset.pgTipo;
			apply();
			next.focus();
		});
	});

	const initial = tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0];
	const initialType = types.find((btn) => btn.classList.contains("is-active")) || types[0];
	day = initial?.dataset.pgDia ?? null;
	type = initialType?.dataset.pgTipo ?? null;
	apply();

	const dialog = page.querySelector("[data-pg-modal]");
	if (!dialog) return;

	const time = dialog.querySelector("[data-pg-time]");
	const share = dialog.querySelector("[data-pg-share]");
	const views = [...dialog.querySelectorAll("[data-pg-view]")];
	let blockOpen = false;

	const closeModal = () => {
		if (!dialog.open) return;
		blockOpen = true;
		dialog.close();
		window.setTimeout(() => {
			blockOpen = false;
		}, 400);
	};

	const show = (id) => {
		if (blockOpen || dialog.open) return;

		let current = null;

		views.forEach((view) => {
			const title = view.querySelector(".pg-modal__title");
			const on = view.dataset.pgView === id;
			view.hidden = !on;
			if (title) title.removeAttribute("id");
			if (on) current = view;
		});

		if (!current) return;

		current.querySelector(".pg-modal__title")?.setAttribute("id", "pg-modal-title");
		if (time) time.textContent = current.dataset.horario || "";
		if (share) {
			share.dataset.titulo = current.dataset.titulo || "";
			share.dataset.copied = "false";
			share.setAttribute("aria-label", "Compartilhar programação");
		}

		if (!dialog.open) dialog.showModal();
		dialog.querySelector("[data-pg-close]")?.focus();
	};

	page.addEventListener("click", (event) => {
		const open = event.target.closest("[data-pg-open]");
		if (!open || !page.contains(open)) return;
		event.preventDefault();
		show(open.dataset.pgOpen);
	});

	dialog.addEventListener("click", (event) => {
		const inPanel = event.target.closest(".pg-modal__panel");
		const closing = event.target.closest("[data-pg-close]");
		if (inPanel && !closing) return;
		event.preventDefault();
		closeModal();
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape" || !dialog.open) return;
		event.preventDefault();
		closeModal();
	});

	share?.addEventListener("click", async () => {
		const titulo = share.dataset.titulo || document.title;
		const url = window.location.href;

		if (navigator.share) {
			try {
				await navigator.share({ title: titulo, text: titulo, url });
				return;
			} catch (error) {
				if (error && error.name === "AbortError") return;
			}
		}

		try {
			await navigator.clipboard.writeText(url);
			share.dataset.copied = "true";
			share.setAttribute("aria-label", "Link copiado");
		} catch (error) {
			share.setAttribute("aria-label", "Não foi possível copiar o link");
		}
	});
}
